import React, { useEffect, useState } from 'react';
import Layout from '../components/Layout';
import { API } from '../api';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export default function ManageTransferBooking() {

  const [data,    setData]    = useState([]);
  const [page,    setPage]    = useState(1);
  const [limit,   setLimit]   = useState(null);
  const [total,   setTotal]   = useState(0);
  const [loading, setLoading] = useState(false);

  // Search filters (mirrors PHP cmbSerPeriod + cmbBookingStatus)
  const [period,    setPeriod]    = useState(0); // 0=All,1=Today,2=Last7,3=Last30
  const [bStatus,   setBStatus]   = useState(0); // 0=Booked, 1=Cancelled
  // Applied filters (only updates on Search click)
  const [appliedPeriod,  setAppliedPeriod]  = useState(0);
  const [appliedStatus,  setAppliedStatus]  = useState(0);

  // View modal
  const [viewRecord, setViewRecord] = useState(null);
  const [viewModal,  setViewModal]  = useState(false);

  /* ── Step 1: Load page limit from tbl_settings ── */
  useEffect(() => {
    API.get('/settings/page-limit')
      .then(res => setLimit(Number(res.data.limit) || 10))
      .catch(()  => setLimit(10));
  }, []);

  /* ── Step 2: Fetch data after limit ready ── */
  useEffect(() => {
    if (limit === null) return;
    fetchData();
  }, [page, limit, appliedPeriod, appliedStatus]);

  const fetchData = () => {
    setLoading(true);
    API.get(`/transfer-bookings?page=${page}&limit=${limit}&period=${appliedPeriod}&status=${appliedStatus}`)
      .then(res => {
        setData(res.data?.data   || []);
        setTotal(res.data?.total || 0);
      })
      .catch(err => {
        console.error('FETCH ERROR:', err.response?.data || err.message);
        toast.error('Failed to load bookings');
        setData([]);
      })
      .finally(() => setLoading(false));
  };

  /* ── Search ── */
  const handleSearch = () => {
    setPage(1);
    setAppliedPeriod(period);
    setAppliedStatus(bStatus);
  };

  /* ── View ── */
  const handleView = (id) => {
    API.get(`/transfer-bookings/${id}`)
      .then(res => {
        setViewRecord(res.data);
        setViewModal(true);
      })
      .catch(() => toast.error('Failed to load record'));
  };

  /* ── Accept ── */
  const handleAccept = async (id) => {
    if (!window.confirm('Accept this booking?')) return;
    try {
      await API.put(`/transfer-bookings/accept/${id}`);
      toast.success('Booking Accepted');
      fetchData();
    } catch {
      toast.error('Failed to accept booking');
    }
  };

  /* ── Reject ── */
  const handleReject = async (id) => {
    if (!window.confirm('Reject this booking?')) return;
    try {
      await API.put(`/transfer-bookings/reject/${id}`);
      toast.success('Booking Rejected');
      fetchData();
    } catch {
      toast.error('Failed to reject booking');
    }
  };

  /* ── Delete ── */
  const handleDelete = async (id) => {
    if (!window.confirm('Are you sure to delete this booking?')) return;
    try {
      await API.delete(`/transfer-bookings/${id}`);
      toast.success('Deleted Successfully');
      fetchData();
    } catch {
      toast.error('Unable to Delete, Try Again');
    }
  };

  const totalPages = limit ? Math.ceil(total / limit) : 1;

  if (limit === null) {
    return (
      <Layout activePage="TransferBooking">
        <div style={S.emptyCell}>Loading settings...</div>
      </Layout>
    );
  }

  return (
    <Layout activePage="TransferBooking">
      <ToastContainer position="top-right" autoClose={3000} />

      {/* ── TOP BAR ── */}
      <div style={S.topbar}>
        <div>
          <h2 style={S.title}>Manage Transfer Booking</h2>
          <p style={S.subtitle}>View and manage transfer bookings</p>
        </div>
      </div>

      {/* ── SEARCH FILTER (mirrors PHP frmbooking form) ── */}
      <div style={S.filterCard}>
        <div style={S.filterRow}>

          {/* Period filter */}
          <div style={S.fg}>
            <label style={S.label}>Period</label>
            <select
              value={period}
              onChange={e => setPeriod(Number(e.target.value))}
              style={S.input}
            >
              <option value={0}>--- All ---</option>
              <option value={1}>Today</option>
              <option value={2}>Last 7 Days</option>
              <option value={3}>Last 30 Days</option>
            </select>
          </div>

          {/* Booking status filter */}
          <div style={S.fg}>
            <label style={S.label}>Booking Status</label>
            <select
              value={bStatus}
              onChange={e => setBStatus(Number(e.target.value))}
              style={S.input}
            >
              <option value={0}>Booked</option>
              <option value={1}>Cancelled</option>
            </select>
          </div>

          {/* Search button */}
          <div style={{ ...S.fg, justifyContent: 'flex-end' }}>
            <label style={{ ...S.label, visibility: 'hidden' }}>Search</label>
            <button style={S.searchBtn} onClick={handleSearch}>
              🔍 Search
            </button>
          </div>

        </div>
      </div>

      {/* ── TABLE CARD ── */}
      <div style={S.card}>
        {loading ? (
          <div style={S.emptyCell}>Loading...</div>
        ) : data.length === 0 ? (
          <div style={{ ...S.emptyCell, color: 'red' }}>--- No Records Found ---</div>
        ) : (
          <table style={S.table}>
            <thead>
              <tr style={S.theadRow}>
                <th style={S.th}>#</th>
                <th style={S.th}>Name</th>
                <th style={S.th}>Email ID</th>
                <th style={S.th}>Mobile No.</th>
                <th style={S.th}>Booking Date</th>
                <th style={S.th}>View</th>
                <th style={S.th}>Delete</th>
                <th style={S.th}>Accept / Reject</th>
              </tr>
            </thead>
            <tbody>
              {data.map((row, i) => (
                <tr key={row.bookingtran_id}>

                  {/* # */}
                  <td style={S.td}>
                    <span style={S.serial}>{(page - 1) * limit + i + 1}</span>
                  </td>

                  {/* Name — mirrors PHP: title. firstname lastname */}
                  <td style={S.td}>
                    <span style={S.nameChip}>
                      {row.online_title}. {row.online_firstname} {row.online_lastname}
                    </span>
                  </td>

                  {/* Email */}
                  <td style={S.td}>
                    <a href={`mailto:${row.online_emailid}`} style={S.mailLink}>
                      {row.online_emailid}
                    </a>
                  </td>

                  {/* Mobile */}
                  <td style={S.td}>{row.online_mobileno}</td>

                  {/* Booking Date */}
                  <td style={S.td}>
                    <span style={S.dateChip}>
                      {row.transfer_bookingdate
                        ? new Date(row.transfer_bookingdate).toLocaleDateString()
                        : '—'}
                    </span>
                  </td>

                  {/* View */}
                  <td style={S.td}>
                    <button
                      style={S.viewBtn}
                      onClick={() => handleView(row.bookingtran_id)}
                    >
                      View
                    </button>
                  </td>

                  {/* Delete */}
                  <td style={S.td}>
                    <button
                      style={S.delBtn}
                      onClick={() => handleDelete(row.bookingtran_id)}
                    >
                      Delete
                    </button>
                  </td>

                  {/* Accept / Reject — mirrors PHP accept_reject toggle */}
                  <td style={S.td}>
                    {row.accept_reject === 1 ? (
                      // Currently accepted → show Reject button
                      <button
                        style={S.rejectBtn}
                        onClick={() => handleReject(row.bookingtran_id)}
                      >
                        ✗ Reject
                      </button>
                    ) : (
                      // Currently rejected/pending → show Accept button
                      <button
                        style={S.acceptBtn}
                        onClick={() => handleAccept(row.bookingtran_id)}
                      >
                        ✓ Accept
                      </button>
                    )}
                  </td>

                </tr>
              ))}
            </tbody>
          </table>
        )}

        {/* ── PAGINATION ── */}
        <div style={S.pagination}>
          <button
            style={{ ...S.pageBtn, opacity: page === 1 ? 0.5 : 1 }}
            disabled={page === 1}
            onClick={() => setPage(p => p - 1)}
          >
            ◀ Prev
          </button>

          <span style={S.pageInfo}>
            Page {page} of {totalPages || 1}
            <span style={{ color: '#aaa', fontWeight: 400, marginLeft: 8 }}>
              ({total} total)
            </span>
          </span>

          <button
            style={{ ...S.pageBtn, opacity: page >= totalPages ? 0.5 : 1 }}
            disabled={page >= totalPages}
            onClick={() => setPage(p => p + 1)}
          >
            Next ▶
          </button>
        </div>
      </div>

      {/* ── VIEW MODAL ── */}
      {viewModal && viewRecord && (
        <div style={S.overlay} onClick={() => setViewModal(false)}>
          <div style={S.modalBox} onClick={e => e.stopPropagation()}>

            <div style={S.modalHead}>
              <span style={{ fontWeight: 700, fontSize: 16 }}>
                Booking Details
              </span>
              <button style={S.closeBtn} onClick={() => setViewModal(false)}>✕</button>
            </div>

            <div style={S.modalBody}>
              {[
                ['Booking ID',    viewRecord.bookingtran_id],
                ['Name',          `${viewRecord.online_title}. ${viewRecord.online_firstname} ${viewRecord.online_lastname}`],
                ['Email',         viewRecord.online_emailid],
                ['Mobile',        viewRecord.online_mobileno],
                ['Booking Date',  viewRecord.transfer_bookingdate],
                ['Status',        viewRecord.status === 1 ? 'Booked' : 'Cancelled'],
                ['Accept/Reject', viewRecord.accept_reject === 1 ? '✓ Accepted' : '✗ Rejected / Pending'],
              ].map(([label, value]) => (
                <div key={label} style={S.detailRow}>
                  <span style={S.detailLabel}>{label}</span>
                  <span style={S.detailValue}>{value || '—'}</span>
                </div>
              ))}
            </div>

            <div style={S.modalFoot}>
              <button style={S.cancelBtn} onClick={() => setViewModal(false)}>Close</button>
            </div>

          </div>
        </div>
      )}

    </Layout>
  );
}


/* ─── Styles ─── */
const S = {
  topbar:   { display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 20 },
  title:    { margin: 0, fontSize: 26, fontWeight: 800, color: '#1a1d2e', letterSpacing: '-0.5px' },
  subtitle: { margin: '4px 0 0', fontSize: 13, color: '#999' },

  /* Filter card */
  filterCard: { background: '#eef0f5', borderRadius: 16, boxShadow: '0 2px 16px rgba(0,0,0,0.06)', padding: '16px 20px', marginBottom: 20 },
  filterRow:  { display: 'grid', gridTemplateColumns: '1fr 1fr auto', gap: 14, alignItems: 'end' },
  fg:         { display: 'flex', flexDirection: 'column', gap: 5 },
  label:      { fontSize: 12, fontWeight: 600, color: '#555' },
  input: {
    padding: '8px 12px', border: '1.5px solid #e0e0e0', borderRadius: 8,
    fontSize: 13, fontFamily: 'inherit', color: '#333', outline: 'none',
    width: '100%', boxSizing: 'border-box', background: '#fff'
  },
  searchBtn: {
    padding: '9px 22px', background: 'linear-gradient(135deg,#6C63FF,#43BCCD)',
    color: '#fff', border: 'none', borderRadius: 10, cursor: 'pointer',
    fontSize: 13, fontWeight: 700, fontFamily: 'inherit', whiteSpace: 'nowrap'
  },

  /* Table */
  card:     { background: '#fff', borderRadius: 16, boxShadow: '0 2px 16px rgba(0,0,0,0.06)', overflow: 'hidden' },
  table:    { width: '100%', borderCollapse: 'collapse' },
  theadRow: { background: '#fafafa' },
  th: {
    padding: '12px 14px', fontSize: 11, fontWeight: 700, color: '#999',
    textAlign: 'center', borderBottom: '2px solid #f0f0f0',
    textTransform: 'uppercase', letterSpacing: '0.5px'
  },
  td:        { padding: '12px 14px', fontSize: 13, color: '#333', borderBottom: '1px solid #f8f8f8', textAlign: 'center' },
  emptyCell: { textAlign: 'center', padding: 40, color: '#bbb', fontSize: 14 },

  /* Chips */
  serial:    { background: '#f3f2ff', color: '#6C63FF', borderRadius: 20, padding: '3px 10px', fontSize: 12, fontWeight: 700 },
  nameChip:  { background: '#f0f8ff', color: '#1a6eb5', borderRadius: 20, padding: '4px 12px', fontSize: 12, fontWeight: 600 },
  dateChip:  { background: '#f5f0ff', color: '#6C63FF', borderRadius: 20, padding: '3px 10px', fontSize: 12, fontWeight: 600 },
  mailLink:  { color: '#1a6eb5', textDecoration: 'none', fontSize: 13 },

  /* Action buttons */
  viewBtn: {
    background: '#f0fff6', color: '#1a9e5c', border: '1px solid #b8f0d0',
    padding: '4px 12px', borderRadius: 20, cursor: 'pointer',
    fontSize: 12, fontWeight: 700, fontFamily: 'inherit'
  },
  delBtn: {
    background: '#fff2f5', color: '#FF6584', border: '1px solid #ffd0d8',
    padding: '4px 12px', borderRadius: 20, cursor: 'pointer',
    fontSize: 12, fontWeight: 700, fontFamily: 'inherit'
  },
  acceptBtn: {
    background: '#f0fff6', color: '#1a9e5c', border: '1px solid #b8f0d0',
    padding: '4px 14px', borderRadius: 20, cursor: 'pointer',
    fontSize: 12, fontWeight: 700, fontFamily: 'inherit'
  },
  rejectBtn: {
    background: '#fff2f5', color: '#FF6584', border: '1px solid #ffd0d8',
    padding: '4px 14px', borderRadius: 20, cursor: 'pointer',
    fontSize: 12, fontWeight: 700, fontFamily: 'inherit'
  },

  /* Pagination */
  pagination: {
    display: 'flex', justifyContent: 'space-between', alignItems: 'center',
    padding: '14px 20px', borderTop: '1px solid #f0f0f0'
  },
  pageBtn: {
    padding: '6px 14px', border: 'none', borderRadius: 8,
    background: '#6C63FF', color: '#fff', cursor: 'pointer',
    fontFamily: 'inherit', fontWeight: 600
  },
  pageInfo: { fontSize: 14, fontWeight: 600 },

  /* Modal */
  overlay: {
    position: 'fixed', inset: 0, background: 'rgba(10,10,30,0.55)',
    zIndex: 999, display: 'flex', alignItems: 'center', justifyContent: 'center',
    backdropFilter: 'blur(2px)'
  },
  modalBox: {
    background: '#fff', borderRadius: 20, width: 520, maxWidth: '96vw',
    maxHeight: '90vh', display: 'flex', flexDirection: 'column',
    boxShadow: '0 24px 60px rgba(0,0,0,0.2)'
  },
  modalHead: {
    display: 'flex', justifyContent: 'space-between', alignItems: 'center',
    padding: '18px 22px', borderBottom: '1px solid #f0f0f0'
  },
  modalBody: { padding: '20px 22px', overflowY: 'auto', flex: 1 },
  modalFoot: {
    display: 'flex', justifyContent: 'flex-end',
    padding: '14px 22px', borderTop: '1px solid #f0f0f0'
  },
  closeBtn: {
    background: '#ff6b6b22', border: 'none', color: '#ff6b6b',
    borderRadius: '50%', width: 30, height: 30, cursor: 'pointer',
    fontWeight: 800, fontSize: 14
  },
  cancelBtn: {
    padding: '9px 20px', background: '#f5f5f5', color: '#666',
    border: 'none', borderRadius: 10, cursor: 'pointer',
    fontSize: 13, fontWeight: 600, fontFamily: 'inherit'
  },

  /* Detail rows in modal */
  detailRow: {
    display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start',
    padding: '10px 0', borderBottom: '1px solid #f5f5f5', gap: 12
  },
  detailLabel: { fontSize: 12, fontWeight: 700, color: '#999', textTransform: 'uppercase', letterSpacing: '0.4px', minWidth: 120 },
  detailValue: { fontSize: 13, color: '#333', fontWeight: 500, textAlign: 'right' },
};